module.exports = __webpack_public_path__ + "media/images/podcast-4-b5cff91e64a25d21ecf434bf70aa793b.jpg";